import { useState } from "react";
import { CallbackNav } from "../../types/Layout";

import TabCustomizer from "./widgets/tabCustomizer";

const ThemeCustomizer = () => {
  const [selected, setSelected] = useState("check-layout");
  const [openCus, setOpenCus] = useState(false);

  const callbackNav: CallbackNav = (select, open) => {
    setSelected(select);
    setOpenCus(open);
  };
  return (
    <>
      <div className={`customizer-links ${openCus ? "open" : ""}`}>
        
      </div>
      <div className={`customizer-contain ${openCus ? "open" : ""}`}>
        <TabCustomizer selected={selected} callbackNav={callbackNav} />
      </div>
    </>
  );
};

export default ThemeCustomizer;